import { render, staticRenderFns } from "./TkTravelType.vue?vue&type=template&id=009652fa&scoped=true&"
import script from "./TkTravelType.vue?vue&type=script&lang=js&"
export * from "./TkTravelType.vue?vue&type=script&lang=js&"
import style0 from "./TkTravelType.vue?vue&type=style&index=0&id=009652fa&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009652fa",
  null
  
)

export default component.exports